import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  Typography,
  Grid,
  IconButton,
  Button,
  LinearProgress,
  Chip,
  Avatar,
  CardContent,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import ClientProfileCard from "./ClientProfileCard";
import { client_men } from "../../iconsImports";
import { projectsData } from "../../utils/constants";
import Tickets from "./Tickets";
import ClientDetailsTable from "./ClientDetailsTable";
import ReusableTable from "./ReusableTable";
import { useLocation } from "react-router-dom";

// Sample Data
const clientInfo = {
    name: "AgilSoft Tech",
    ceo: "Ryan Ogden",
    email: "ryanogden@gmail.com",
    phone: "202-555-0174",
    dob: "19/03/1980",
    position: "Ryan Ogden",
    image: client_men,
    address: "2734 West Fork Street, EASTON 02334",
    details: "Vestibulum ante ipsum primis in faucibus orci luctus et ultrices. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices."
  };
  

const projects = [
  { id: 1, title: "UI/UX Design", team: "Social Geek Made", progress: 75, daysLeft: 35 },
  { id: 2, title: "Website Design", team: "Practice to Perfect", progress: 80, daysLeft: 35 },
];
 
const tasks = [
  { id: 1, title: "UI/UX Design", status: "In Progress", team: "Social Geek Made", color: "orange" },
  { id: 2, title: "Website Design", status: "Review", team: "Practice to Perfect", color: "red" },
  { id: 3, title: "Quality Assurance", status: "Completed", team: "Social Geek Made", color: "green" },
];

const columns = [
    { id: "projectId", label: "No" },
    { id: "projectname", label: "Project" },
    { id: "start_date", label: "Start Date" },
    { id: "end_date", label: "End Date" },
    { id: "amount", label: "Amount" },
    { id: "status", label: "Status" },
  ];
  
  const data = [
    { projectId: "#00002", projectname: "Practice to Per...", start_date: "12-02-2021", end_date: "N/A", amount: "$1578", status: "Paid" },
    { projectId: "#00004", projectname: "Box of Crayons", start_date: "28-02-2021", end_date: "N/A", amount: "$1973", status: "Draft" },
    { projectId: "#00003", projectname: "Rhinestone", start_date: "18-02-2021", end_date: "N/A", amount: "$1978", status: "Draft" },
    { projectId: "#00011", projectname: "Social Geek M...", start_date: "10-01-2021", end_date: "N/A", amount: "$3250", status: "Pending" },
  ];

const ClientProfile = () => {
    const [filteredProjects, setFilteredProjects] = useState([]);
  
    const location = useLocation();
    const client = location.state?.client||1;
    console.log("client data is ",client);
    const filterId = client.id;
useEffect(() => {
    const filtered = projectsData.filter((item) => item.id === filterId);
    setFilteredProjects(filtered);
  }, [projectsData]);
  return (
    <Box sx={{ padding: 4, backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom sx={{textAlign:"left"}} >
        Client Profile
      </Typography>

      <Grid container spacing={2}>
  
        <Grid item xs={12} md={8}>
         
            <ClientProfileCard clientData={client} client={clientInfo} />
          
          <Typography variant="h5" fontWeight="bold" mt={4} sx={{textAlign:"left"}} gutterBottom>
            Current Client Projects
          </Typography>

          <Grid container spacing={2}>
          {filteredProjects.map((project) => (
          <Grid item xs={12} sm={12} md={6} key={project.id}>
            <Card sx={{ p: 2 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Avatar>{project.icon}</Avatar>
                <Typography>{project.category}</Typography>
              </Box>

              <CardContent>
                
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2 }}>
  {/* Left Side - Project Title */}
  <Typography variant="h6">{project.title}</Typography>

  {/* Right Side - Buttons */}
  <Box sx={{ display: "flex", gap: 1 }}>
    <IconButton color="success">
      <Edit />
    </IconButton>
    <IconButton color="error">
      <Delete />
    </IconButton>
  </Box>
</Box>

<Grid container spacing={2} sx={{ mt: 2,justifyContent:"flex-start" }}>
  {/* First Row */}
  <Grid item xs={6}>
    <Typography>📎 {project.attachments} Attach</Typography>
  </Grid>
  <Grid item xs={6}>
    <Typography>⏳ {project.duration}</Typography>
  </Grid>

  {/* Second Row */}
  <Grid item xs={6}>
    <Typography>👥 {project.members} Members</Typography>
  </Grid>
  <Grid item xs={6}>
    <Typography>💬 {project.comments}</Typography>
  </Grid>
</Grid>

<Box sx={{ mt: 2 }}>
  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
    <Typography>Progress</Typography>
    <Typography sx={{ borderRadius: 1 }}>⏳ {project.daysLeft} Days Left</Typography>
  </Box>
  <Box sx={{mt:2}}>
  <LinearProgress variant="determinate" sx={{
      bgcolor: "#e0e0e0", // Background color of the progress bar track
      "& .MuiLinearProgress-bar": {
        backgroundColor: "#eb9234", // Color of the progress indicator
      },
    }} value={project.progress} />
  </Box>
</Box>

              </CardContent>
            </Card>
          </Grid>
        ))}
          </Grid>


          <Grid>

          <ReusableTable columns={columns} data={data} />
          </Grid>
        </Grid>

        {/* Right Side: Client Tasks (4 columns) */}
        <Grid item xs={12} md={4}>
          <Card sx={{ padding: 2 }}>
            <Typography variant="h5" fontWeight="bold" sx={{textAlign:"left"}}gutterBottom>
              Client Tasks
            </Typography>

            <Grid container spacing={2}>
              {tasks.map((task) => (
                <Grid item xs={12} key={task.id}>
                  <Card sx={{ padding: 2 }}>
                    <Box sx={{display:"flex",justifyContent:"space-between"}}>
                    <Typography variant="subtitle1" sx={{textAlign:"left"}} fontWeight="bold">
                      {task.id}. {task.title}
                    </Typography>
                    <Chip label={task.status} sx={{ backgroundColor: task.color, color: "white",textAlign:"right",justifyContent:"flex-end" }} />
                    </Box>
                    <Typography variant="body2" color="gray" sx={{textAlign:"left"}}>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </Typography>

                    <Box display="flex" justifyContent="flex-end" mt={2}>
                    <Chip label={task.team} color="secondary" size="small" />
</Box>

                  </Card>
                </Grid>
              ))}
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ClientProfile;
